import React from 'react';
import PropTypes from 'prop-types';
import MapLocationIcon from '../../images/icons/map-location.svg';
import './styles.less';

export default class ClosestBrandRetailer extends React.Component {
  static propTypes = {
    brandName: PropTypes.string.isRequired,
    distance: PropTypes.number.isRequired,
    classNames: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.string
    ])
  };

  render() {
    const distance = this.props.distance;
    const distanceText = distance < 1
      ? 'less than a mile away'
      : distance > 5
        ? 'more than 5 miles away'
        : Math.ceil(this.props.distance) + ' miles away';

    const classNames = ['closest-brand-retailer-component'].concat(this.props.classNames);
    return (
      <span className={classNames.join(' ')}>
        <img role="presentation" src={MapLocationIcon}/>
        <span className="text">Nearest known stockist <strong>{distanceText}</strong>.</span>
    </span>);
  }
}


/** WEBPACK FOOTER **
 ** ./src/components/ClosestBrandRetailer/index.jsx
 **/